export default [
    {
        name: 'profile',
        path: '/profile',
        component: () => import('@/views/profile/index.vue'),
        meta: {
            openAccess: true,
            layout: 'authenticated'
        }
    }
];
